// extracted by css-extract-rspack-plugin
export default {"wrapper":"hQ9H_V3HLLEiB_5S","singleLine":"bmHSYv2yrcqq77hO","multiLine":"Xb12GmbJvk0vKt6R","tooltip":"m2CdUA_jMLwnNzMJ"};